import { InvalidPlaybackQueueSnapshotError, } from '../ports/playback-event-store.js';
import { META_STORE, openPlayerDatabase } from './idb/database.js';
import { idbRequest, idbTransactionDone } from './idb/request.js';
/** Own key in the existing meta store: no new database and no schema version bump. */
const META_PLAYBACK_EVENTS = 'playbackEvents';
export class IndexedDbPlaybackEventStore {
    openDb;
    dbPromise = null;
    constructor(openDb = openPlayerDatabase) {
        this.openDb = openDb;
    }
    db() {
        if (!this.dbPromise)
            this.dbPromise = this.openDb();
        return this.dbPromise;
    }
    async load() {
        const db = await this.db();
        const record = await idbRequest(db.transaction(META_STORE, 'readonly').objectStore(META_STORE).get(META_PLAYBACK_EVENTS));
        const value = record ? record.value : null;
        if (value === null || value === undefined)
            return [];
        if (Array.isArray(value))
            return value;
        const snapshot = value;
        if (snapshot.version !== 1 ||
            typeof snapshot.queueId !== 'string' ||
            !Array.isArray(snapshot.events) ||
            !Number.isSafeInteger(snapshot.droppedEvents) ||
            snapshot.droppedEvents < 0 ||
            !Number.isSafeInteger(snapshot.acknowledgedDroppedEvents) ||
            snapshot.acknowledgedDroppedEvents < 0 ||
            snapshot.acknowledgedDroppedEvents > snapshot.droppedEvents)
            throw new InvalidPlaybackQueueSnapshotError('Invalid playback queue snapshot', Array.isArray(snapshot.events) ? snapshot.events.length : 0);
        return snapshot;
    }
    async save(snapshot) {
        const db = await this.db();
        const tx = db.transaction(META_STORE, 'readwrite');
        const record = { key: META_PLAYBACK_EVENTS, value: snapshot };
        const done = idbTransactionDone(tx);
        tx.objectStore(META_STORE).put(record);
        await done;
    }
}
//# sourceMappingURL=indexed-db-playback-event-store.js.map